import React from 'react';
import { Store, ShoppingBag, Truck } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const ServicesSection = ({ services }) => {
  const getServiceIcon = (iconName) => {
    const icons = { Store, ShoppingBag, Truck };
    const Icon = icons[iconName] || Store;
    return <Icon className="w-10 h-10" />;
  };

  return (
    <section className="py-16 px-6 bg-white">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <Card key={service.id} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <CardContent className="p-8 text-center space-y-4">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-cream rounded-full text-caramel">
                  {getServiceIcon(service.icon)}
                </div>
                <h3 className="text-2xl font-bold text-chocolate">{service.title}</h3>
                <p className="text-chocolate-light">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
